module.exports = __webpack_public_path__ + "static/media/_Start.51a468f0.mp4";